const getClientIdInternal = async () => {
    if (typeof window.gtag !== 'undefined') {
        return new Promise(resolve => {
            window.gtag('get', window.variables.analyticsId, 'client_id', resolve);
        });
    }

    if (typeof window.ga !== 'undefined') {
        // Check that Google Analytics is loaded as advised here:
        // https://developer.mozilla.org/en-US/docs/Mozilla/Firefox/Privacy/Tracking_Protection
        if (!window.ga.loaded) {
            return null;
        }

        const tracker = window.ga.getAll().find(tracker => tracker.get('clientId'));
        return tracker && tracker.get('clientId');
    }

    return null;
};

const timeout = (promise, timeout, defaultValue) =>
    Promise.race([
        promise,
        new Promise(resolve => setTimeout(() => resolve(defaultValue), timeout)),
    ]);

export function getAnalyticsClientId() {
    // Wait at most 300ms for the analytics id to resolve
    // This is necessary because some browsers block GA entirely, so the promise will never finish waiting
    return timeout(getClientIdInternal(), 300, null);
}
